module.exports = __webpack_public_path__ + "static/mobile-screen-cracked-578f5a582ee10a52c7be6c5276c5fe55.jpg";